import { Anchor, Text } from '@mantine/core'

// The credit line under a station page: the station's own `attribution`
// (UKHO, BOM) followed by the forecast payload's `attribution[]`, joined with
// a middle dot. Any URL inside a credit renders as a link because at least one
// licence requires it: the Bureau of Meteorology's agreement wants its
// acknowledgement linked to bom.gov.au/copyright on every page that shows
// BOM data (clause 2.4). The strings stay data, exactly as the server and the
// weather CDN send them; only the URL becomes clickable.
const URL_RE = /(https?:\/\/[^\s]+?)([.,;)]*)(?=\s|$)/g

export function linkify(text) {
  const parts = []
  let last = 0
  for (const match of text.matchAll(URL_RE)) {
    const [whole, url, trailing] = match
    if (match.index > last) parts.push(text.slice(last, match.index))
    parts.push({ url })
    if (trailing) parts.push(trailing)
    last = match.index + whole.length
  }
  if (last < text.length) parts.push(text.slice(last))
  return parts
}

export default function Credits({ items }) {
  const credits = (items || []).filter(Boolean)
  if (credits.length === 0) return null
  return (
    <Text size="xs" c="dimmed" ta="center" data-testid="station-credits">
      {credits.map((credit, i) => (
        <span key={i}>
          {i > 0 && ' · '}
          {linkify(credit).map((part, j) =>
            typeof part === 'string' ? (
              part
            ) : (
              <Anchor
                key={j}
                href={part.url}
                target="_blank"
                rel="noopener"
                c="dimmed"
                underline="always"
              >
                {part.url.replace(/^https?:\/\//, '')}
              </Anchor>
            ),
          )}
        </span>
      ))}
    </Text>
  )
}
